import component from "./Number";

export default component;
